export function getPageTitle(pageTitle, title = '上海交通大学中银科技金融学院') {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
